<template>
    <v-card>
        <div>
            <v-img
                :src="convenio.url_imagem_codigo ? convenio.url_imagem_codigo : require('@/assets/posto-default.png')"
                aspect-ratio="2.75"
            >
            </v-img>
        </div>
        <v-card-text>
            <v-layout pt-4 row wrap justify-space-around fill-height>
                <v-flex xs12 sm5>
                    <v-text-field
                        readonly
                        label="Nome do convênio"
                        v-model="convenio.nome_convenio"
                    ></v-text-field>
                </v-flex>
                <v-flex xs12 sm5>
                    <v-text-field
                        readonly
                        label="Códidgo"
                        v-model="convenio.codigo"
                    ></v-text-field>
                </v-flex>
                <v-flex xs12 sm11 v-if="convenio.representante">
                    <v-text-field
                        readonly
                        label="CPF do representante"
                        v-model="convenio.representante.cpf"
                        mask="###.###.###-##"
                        class="text-xs-center"
                    ></v-text-field>
                </v-flex>
                <v-flex xs5 v-if="convenio.representante">
                    <v-text-field
                        readonly
                        label="Nome do Representante"
                        v-model="convenio.representante.nome"
                    ></v-text-field>
                </v-flex>
                <v-flex xs5 v-if="convenio.representante">
                    <v-text-field
                        readonly
                        label="Sobrenome do Representante"
                        v-model="convenio.representante.sobrenome"
                    ></v-text-field>
                </v-flex>
                 <v-flex xs4 v-if="convenio.representante">
                    <v-text-field
                        readonly
                        label="Telefone do Representante"
                        v-model="convenio.representante.telefone"
                        mask="(##) # ####-####"
                    ></v-text-field>
                </v-flex>
                <v-flex xs7 v-if="convenio.representante">
                    <v-text-field
                        readonly
                        label="Email do Representante"
                        v-model="convenio.representante.email"
                    ></v-text-field>
                </v-flex>
                <v-flex xs5 v-if="convenio.instituicao_representante">
                    <v-text-field
                        readonly
                        label="Nome da Instituição"
                        v-model="convenio.instituicao_representante.nome"
                    ></v-text-field>
                </v-flex>
                <v-flex xs5 v-if="convenio.instituicao_representante">
                    <v-text-field
                        readonly
                        label="Tipo"
                        v-model="convenio.instituicao_representante.tipo"
                    ></v-text-field>
                </v-flex>
                 <v-flex xs12 sm5 v-if="convenio.instituicao_representante">
                    <v-text-field
                        readonly
                        label="CNPJ"
                        v-model="convenio.instituicao_representante.cnpj"
                        mask="##.###.###/####-##"
                        class="text-xs-center"
                    ></v-text-field>
                </v-flex>
                <v-flex xs5 v-if="convenio.instituicao_representante">
                    <v-text-field
                        readonly
                        label="Telefone da instituição"
                        v-model="convenio.instituicao_representante.telefone"
                        mask="(##) # ####-####"
                    ></v-text-field>
                </v-flex>
            </v-layout>
        </v-card-text>
        <v-card-actions>
            <v-btn flat block @click="$emit('fechar')">Voltar</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
  props: ['convenio']
}
</script>
